import { createUseStyles } from 'react-jss';
var useStyles = createUseStyles(function (_ref) {
  var palette = _ref.palette,
    border = _ref.border,
    radius = _ref.radius,
    breakpoints = _ref.breakpoints;
  return {
    wrapper: function wrapper(_ref2) {
      var fullscreen = _ref2.fullscreen;
      return !fullscreen ? {} : {
        display: 'flex',
        justifyContent: 'center',
        padding: '150px 0'
      };
    },
    innerWrapper: {
      maxWidth: breakpoints.sm
    },
    title: {
      '& *': {
        lineHeight: '1.3'
      }
    },
    outerBox: {
      // converting border to string as workaround to JSS bug (unable to pass in styles while using a border array)
      border: "".concat(border.main[0], "px ").concat(border.main[1], " ").concat(border.main[2]),
      borderRadius: radius.small,
      backgroundColor: palette.background.light
    },
    content: {
      '& p': {
        lineHeight: '1.4',
        margin: 0
      }
    }
  };
});
export default useStyles;
//# sourceMappingURL=useStyles.js.map